export default "__VITE_ASSET__DUjjKXAs__"